module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/dependent-details/dependent-grid/dependent-grid.component.css
// module id = ./src/app/hrms/serviceregister/dependent-details/dependent-grid/dependent-grid.component.css
// module chunks = main